import { Carousel } from "../components/Carousel";
import { uamSlides, achievements, timeline } from "../data/content";

export function TrayectoriaSection() {
	return (
		<section className="section section--alt" id="trayectoria">
			<div className="content-wrap reveal">
				<div className="section__label">Trayectoria</div>
				<h2 className="section__heading">Una vida de servicio y lucha.</h2>
				<p className="section__intro">
					Su carrera profesional comenzó en la Defensoría de Derechos
					Universitarios de la UAM, sin olvidar todo el trabajo político
					estudiantil y social que la precedió. Como secretaria general
					(2020–2022), la DDU logró vincularse con múltiples organizaciones y
					universidades. Posteriormente fue co-coordinadora de la Unidad de Género
					del Instituto Mora.
				</p>
			</div>

			<div className="content-wrap--wide reveal">
				<div className="achievements-grid">
					{achievements.map((a, i) => (
						<div className="achievement-card" key={i}>
							<div className="achievement-card__number">{a.n}</div>
							<div className="achievement-card__title">{a.t}</div>
							<div className="achievement-card__desc">{a.d}</div>
						</div>
					))}
				</div>
			</div>

			<div className="content-wrap reveal">
				<div className="timeline">
					{timeline.map((t, i) => (
						<div className="timeline-item" key={i}>
							<div className="timeline-item__year">{t.year}</div>
							<div className="timeline-item__line" />
							<div>
								<div className="timeline-item__event">{t.event}</div>
								<div className="timeline-item__desc">{t.desc}</div>
							</div>
						</div>
					))}
				</div>
			</div>

			<div className="content-wrap--wide">
				<Carousel slides={uamSlides} title="UAM y vida académica" />
			</div>
		</section>
	);
}
